export const limitCount = (count: number): string | number => {
    if (count > 99) return '99+';

    return count;
};
